import moment from 'js/helpers/moment'

import api from 'js/api/resources'
import track from 'js/helpers/analytics';
import { transform } from 'js/vuex/helpers'

export default {
    methods: {

        /**
         * Searches for any holidays during the given date
         * @param  {Moment} date
         * @return {Array}      array of holiday objects
         */
        holidaysForDate: function(date) {
            return this.holidays
                .filter( h => h.startdate.isSameOrBefore(date) && h.enddate.isSameOrAfter(date) )
        },

        /**
         * Makes sure the given period is adjusted for the current holidays
         * Adjusts the start date and the duration of each of its blocks
         * @param  {Period} period
         */
        holidayShift: function(period) {

            period.start = this.holidayShiftDate(period.start)

            period.blocks.reduce( (date, block, i, arr) => {

                // greedily include holidays in block (i.e. blocks always start *after* a holiday)
                // except for the lastblock, which should stop before a holiday
                const isLastBlock = i === arr.length-1

                block.duration = this.holidayShiftDuration(date, block.duration, !isLastBlock)

                // use date in next iteration
                return date.clone().add( block.duration, 'weeks')

            }, period.start)
        },


        /**
         * Checks for holidays during the given start+duration combination
         * Extends the duration such that it includes the duration of the found holidays
         * @param  {Moment} startDate start date to check
         * @param  {Number} duration  weeks to check
         * @param  {Boolean} trailing  flag to check trailing part of duration (greedy add holidays) or the leading part (stop before holiday)
         * @return {Number}           the adjusted duration (in weeks)
         */
        holidayShiftDuration: function(startDate, duration, trailing) {

            const start = trailing ? 1 : 0
            const end = trailing ? duration : duration - 1

            let shiftedDuration = duration
            for (let i = start; i <= end; i++) {
                const date = startDate.clone().add(i, 'weeks')
                const shiftedDate = this.holidayShiftDate(date)
                const diff = shiftedDate.diff(date, 'weeks')
                shiftedDuration += diff
                i += diff
            }

            return shiftedDuration

        },

        /**
         * Checks for holidays for the given date and moves the date to after the holidays
         * @param  {Moment} date      date to check
         * @return {Moment}           adjusted date after all holidays
         */
        holidayShiftDate: function(date) {
            return this.holidaysForDate(date).reduce( (longest, h) => {
                const end = h.enddate.clone().add(1, 'week').startOf('week')
                return moment.max(end, longest)
            }, date)
        },

        fetchHolidays: function(schoolId) {

            return api.getHolidays(schoolId)
                .then( response => transform(response.body))
                .then( result => {
                    this.holidays = (result.holidays || []).map( h => {
                        h.startdate = moment.unix(h.start)
                        h.enddate = moment.unix(h.end)
                        return h
                    })
                })
                .catch( err => {
                    track.exception(err)
                })

        }

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/groups/settings/holidaysMixin.js